import React from 'react';
import { Upload } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { PaperClipOutlined } from '@ant-design/icons';
import { AddDiv, StyledPlus, StyledRow, StyledCol, Label } from './StyledComponents';
import { StyledPrimaryText } from '../SPMultiSelectDropdown/StyledComponents';
import UploadedItem from '../UploadedItem';
import PlusIcon from '../../assets/svgIcon/plusIcon';

function SPUpload({
  id,
  value,
  name,
  label,
  onInputChange,
  onBlur,
  disabled,
  width,
  accept,
  multiple = false,
  hasLabel,
  showClip
}) {
  return (
    <StyledRow>
      <StyledCol hasLabel>
        {
          hasLabel &&
          <div>
            <Label>
              Logo (dimensions must be 240 * 72 pixels)
            </Label>
          </div>
        }

        <Upload
          multiple={multiple}
          id={id}
          onBlur={onBlur}
          showUploadList={false}
          maxCount={multiple ? 1 : undefined}
          disabled={disabled}
          beforeUpload={() => false}
          accept={accept || '.png, .jpg, .jpeg, .doc, .docx ,.gif, .xls, .xlsx, .pdf, .txt, .ppt, .eml, .csv, .zip, .rar'}
          onChange={e => {
            let dimestion = {};
            if (e.file) {
              var img = new Image();
              img.src = window.URL.createObjectURL(e.file);
              img.onload = function () {
                dimestion = {
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                };
                window.URL.revokeObjectURL(img.src);
                onInputChange(name, e.file, dimestion);
              };

              img.onerror = function (err) {
                onInputChange(name, e.file, dimestion);
              };
            }
          }}
        >
          <AddDiv width={width}>
            <StyledPrimaryText> {label} </StyledPrimaryText>
            {
              showClip ?
                <PaperClipOutlined style={{ fontSize: '1.2rem' }} />
                :
                <StyledPlus>
                  <PlusIcon />
                </StyledPlus>
            }
          </AddDiv>
        </Upload>
      </StyledCol>
      <StyledCol>
        {!isEmpty(value) ? (
          <UploadedItem
            name={value.name}
            onRemove={() => {
              onInputChange(name, {});
            }}
          />
        ) : null}
      </StyledCol>
    </StyledRow>
  );
}

export default SPUpload;
